export default "__VITE_ASSET__NBS4_E3H__"